import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'libIKPEscapeText', standalone: true })
export class EscapeTextPipe implements PipeTransform {
  /**
   * Removes all whitespace and commas from the input string. Used to sanitize text for data test id usecases.
   * @param input The string to be transformed.
   * @returns The transformed string with all whitespace and commas removed.
   */
  transform(input: string): string {
    return input.replace(/[\s,]/g, '');
  }
}
